var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0", outlined: "", "min-height": "350" } },
    [
      _c(
        "v-card-title",
        {
          staticClass:
            "py-1 white--text d-flex align-center justify-space-between",
          class: _vm.$vuetify.theme.dark ? "black" : "primary",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "white", medium: "" } },
                [_vm._v("subdirectory_arrow_right")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "white--text body-font body-1 font-weight-bold text-uppercase",
                },
                [_vm._v(_vm._s(_vm.$t("table.usersOfClient.lastLogin")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        {
          staticClass: "d-flex flex-column",
          staticStyle: { "padding-top": "0px !important" },
        },
        [
          !_vm.loading
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center justify-space-between mb-3",
                  },
                  [
                    _c("v-text-field", {
                      staticClass: "ms-2",
                      staticStyle: { "max-width": "250px" },
                      attrs: {
                        "hide-details": "",
                        dense: "",
                        "single-line": "",
                        label: "Search",
                        "append-icon": "arrow_drop_down",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "body-1" }, [
                                  _vm._v(_vm._s(_vm.$t("general.search"))),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3961737664
                      ),
                      model: {
                        value: _vm.search,
                        callback: function ($$v) {
                          _vm.search = $$v
                        },
                        expression: "search",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex align-center" },
                      [
                        _c("v-checkbox", {
                          staticClass: "mr-3",
                          attrs: { "hide-details": "" },
                          on: {
                            change: function ($event) {
                              return _vm.onInputChange()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("span", { staticClass: "body-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("dashboards.hideNoConnected")
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            65843153
                          ),
                          model: {
                            value: _vm.hideNonLoggedIn,
                            callback: function ($$v) {
                              _vm.hideNonLoggedIn = $$v
                            },
                            expression: "hideNonLoggedIn",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-checkbox", {
                          attrs: { "hide-details": "" },
                          on: {
                            change: function ($event) {
                              return _vm.onInputChange()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c("span", { staticClass: "body-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("dashboards.onlyTrial"))
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3599940985
                          ),
                          model: {
                            value: _vm.showOnlyTrial,
                            callback: function ($$v) {
                              _vm.showOnlyTrial = $$v
                            },
                            expression: "showOnlyTrial",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-data-table", {
                  attrs: {
                    dense: "",
                    "disable-items-per-page": "",
                    "multi-sort": "",
                    headers: _vm.lastLoginHeaders,
                    items: _vm.filteredClientsData,
                    "footer-props": {
                      itemsPerPageOptions: _vm.$vuetify.breakpoint.smAndDown
                        ? [1]
                        : [5],
                    },
                    search: _vm.search,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "item.name",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: `/administration?clientId=${item.id}`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(item.name))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.username",
                        fn: function ({ item }) {
                          return [
                            item.username
                              ? _c(
                                  "router-link",
                                  { attrs: { to: `/user/${item.userId}` } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-ellipsis body-1" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getUsernameText(item))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                      {
                        key: "item.lastLogin",
                        fn: function ({ item }) {
                          return [
                            item.lastLogin
                              ? _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(item.lastLogin))]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(_vm.$t("general.never")))]
                                ),
                          ]
                        },
                      },
                      {
                        key: "item.daysPassed",
                        fn: function ({ item }) {
                          return [
                            item.daysPassed
                              ? _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(item.daysPassed))]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v("-")]
                                ),
                          ]
                        },
                      },
                      {
                        key: "item.daysRemaining",
                        fn: function ({ item }) {
                          return [
                            item.daysRemaining
                              ? _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(item.daysRemaining))]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "text-ellipsis body-1" },
                                  [_vm._v(_vm._s(_vm.$t("general.unlimited")))]
                                ),
                          ]
                        },
                      },
                      {
                        key: "item.warning",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: {
                                  color: "lightSecondary lighten-4",
                                  top: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          item.warningColor
                                            ? _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass: "me-2",
                                                    attrs: {
                                                      color: item.warningColor,
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v("warning")]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                item.warningText
                                  ? _c(
                                      "span",
                                      { staticClass: "black--text body-1" },
                                      [_vm._v(_vm._s(item.warningText))]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    731150394
                  ),
                }),
              ]
            : [
                _c(
                  "div",
                  {
                    staticClass:
                      "py-3 d-flex justify-space-between align-center",
                  },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "ma-0",
                      attrs: { type: "text", width: "150px" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("v-skeleton-loader", {
                          staticClass: "mr-3",
                          attrs: { type: "text", width: "100px" },
                        }),
                        _vm._v(" "),
                        _c("v-skeleton-loader", {
                          attrs: { type: "text", width: "100px" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "py-4 flex-grow-1 d-flex flex-column justify-space-around",
                  },
                  _vm._l(5, function (i) {
                    return _c("v-skeleton-loader", {
                      key: i,
                      staticClass: "my-2",
                      attrs: { type: "text", width: "100%" },
                    })
                  }),
                  1
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }